export const testimonials = [
  {
    id: '1',
    name: '吃瓜群众小王',
    role: '资深用户·3年',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20on%20clean%20neutral%20background%2C%20soft%20lighting%2C%20friendly%20expression%2C%20corporate%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '91免费真的是我每天必刷的网站！更新速度超快，有什么大事第一时间就能看到。吃瓜吃到饱，而且内容质量也很高，不是那种低质标题党。推荐给所有爱吃瓜的朋友！',
  },
  {
    id: '2',
    name: '娱乐圈观察员',
    role: '自媒体博主·2年',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20young%20woman%20on%20clean%20neutral%20background%2C%20soft%20lighting%2C%20confident%20expression%2C%20modern%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '作为自媒体人，91免费是我的重要信息来源之一。热点追踪非常及时，黑料扒得也够深。很多独家内容都是在这里首发，比微博热搜还快！必须五星好评。',
  },
  {
    id: '3',
    name: '八卦小能手',
    role: '忠实粉丝·1年',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20young%20person%20on%20clean%20neutral%20background%2C%20soft%20lighting%2C%20smiling%20expression%2C%20casual%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
    rating: 4,
    content: '网站设计很清爽，分类也很清晰。明星八卦、网红爆料、黑料吃瓜分门别类，看着很方便。唯一希望的是能增加一个夜间模式，晚上刷瓜的时候眼睛不会太累哈哈。',
  },
  {
    id: '4',
    name: '深夜吃瓜人',
    role: '活跃用户·2年',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20on%20clean%20neutral%20background%2C%20soft%20lighting%2C%20thoughtful%20expression%2C%20modern%20style&width=100&height=100&seq=avatar-04&orientation=squarish',
    rating: 5,
    content: '每天晚上睡前必做的事情就是刷一遍91免费看看今天又有什么新瓜。内容更新的频率和质量都让人满意，很多深度扒皮文章写得特别有意思，比看剧还精彩！',
  },
  {
    id: '5',
    name: '追星少女CC',
    role: '新用户·3个月',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20of%20a%20young%20woman%20on%20clean%20neutral%20background%2C%20soft%20lighting%2C%20bright%20expression%2C%20trendy%20style&width=100&height=100&seq=avatar-05&orientation=squarish',
    rating: 5,
    content: '朋友推荐来的，一用就停不下来了！追星女孩的福音，爱豆的最新动态这里都有。而且评论区也很有意思，大家都是真性情，氛围超好。已经安利给闺蜜了！',
  },
  {
    id: '6',
    name: '老瓜农张叔',
    role: '骨灰级用户·5年',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20headshot%20on%20clean%20neutral%20background%2C%20soft%20lighting%2C%20friendly%20mature%20expression%2C%20relaxed%20style&width=100&height=100&seq=avatar-06&orientation=squarish',
    rating: 5,
    content: '从创立初期就在用了，见证了91免费一路的成长。内容质量一直在提升，现在已经是圈内公认的头部平台了。希望能继续保持初心，为大家带来更多优质内容！',
  },
];

export const aboutFeatures = [
  {
    id: '1',
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    description: '7×24小时实时监控全网热点，第一时间推送最新八卦动态，让你永远站在吃瓜第一线。',
  },
  {
    id: '2',
    icon: 'ri-shield-check-line',
    title: '深度扒皮',
    description: '专业编辑团队深度挖掘事件真相，多角度还原事实，拒绝标题党，做有态度的娱乐媒体。',
  },
  {
    id: '3',
    icon: 'ri-group-line',
    title: '社区互动',
    description: '百万级活跃用户社区，开放评论区畅所欲言，和志同道合的吃瓜群众一起讨论交流。',
  },
  {
    id: '4',
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '支持网页端、手机端、APP多平台无缝切换，随时随地追更，不错过任何精彩内容。',
  },
  {
    id: '5',
    icon: 'ri-lock-line',
    title: '隐私保护',
    description: '严格保护用户隐私数据，匿名评论功能让您安心吃瓜，无需担心个人信息泄露。',
  },
  {
    id: '6',
    icon: 'ri-rocket-line',
    title: '独家首发',
    description: '与多家娱乐媒体和业内人士建立合作关系，众多独家爆料内容仅在91免费首发。',
  },
];